module.exports = __webpack_public_path__ + "static/media/virusBlue.0569c444.png";